const RISK_SCORE_THRESHOLD = 60;

enum MonitoringStatusEnum {
  ACTIVE = 0,
  DISABLED = 5,
  PENDING = 10,
}

const MonitoringStatusNames: Record<MonitoringStatusEnum, string> = {
  [MonitoringStatusEnum.ACTIVE]: 'active',
  [MonitoringStatusEnum.DISABLED]: 'disabled',
  [MonitoringStatusEnum.PENDING]: 'pending',
};

export { RISK_SCORE_THRESHOLD, MonitoringStatusEnum, MonitoringStatusNames };
